import React from "react";
import Spin from "components/Spin";

export default function FullMask({ page, children }) {
    const className = "full-mask" + (page ? " full-mask-page" : "");
    return (
        <div className={className}>
            <div className="full-mask-inside">
                {children || <Spin style={{ fontSize: 40 }} />}
            </div>
        </div>
    );
}
